import { render, staticRenderFns } from "./UiDetail.vue?vue&type=template&id=cab303fe&scoped=true"
import script from "./UiDetail.vue?vue&type=script&lang=js"
export * from "./UiDetail.vue?vue&type=script&lang=js"
import style0 from "./UiDetail.vue?vue&type=style&index=0&id=cab303fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cab303fe",
  null
  
)

export default component.exports